import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Footer from './components/common/Footer'
import IroriTourismSite from './components/IroriTourismSite'
import VipCarDetail from './pages/VipCarDetail'
import ChibaGourmetDetail from './pages/ChibaGourmetDetail'
import NationwideTransportDetail from './pages/NationwideTransportDetail'
import ChakraTestPage from './pages/ChakraTestPage'
import ImageTestComponent from './components/debug/ImageTestComponent'
import { VehicleLineupDemo } from './components/templates'
import LanguageTestComponent from './components/debug/LanguageTestComponent'

// 言語ハンドリング用コンポーネント
const LangHandler = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const params = location.pathname.split('/');
  const lang = params[1]; // 最初のスラッシュの後のパス部分が言語コード
  
  // サポートしている言語か確認、非対応の場合はルートにリダイレクト
  useEffect(() => {
    if (['ja', 'en', 'th'].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // 対応していない言語パスの場合はホームにリダイレクト
  if (!['ja', 'en', 'th'].includes(lang)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

// スクロール処理用のコンポーネント
const ScrollToSection = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // URLにハッシュが含まれている場合、該当セクションにスクロール
    if (location.hash) {
      const elementId = location.hash.substring(1); // # を除去
      const element = document.getElementById(elementId);
      if (element) {
        // 少し遅延を入れてレンダリング完了後にスクロール
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }
    } else {
      // ハッシュがない場合はページトップにスクロール
      window.scrollTo(0, 0);
    }
  }, [location]);

  return children;
};

function App() {
  const { i18n } = useTranslation();
  
  return (
    <Router>
      <div className="App">
        <ScrollToSection>
          <Routes>
            {/* ルートへのアクセスはデフォルト言語にリダイレクト */}
            <Route path="/" element={<IroriTourismSite />} />
            
            {/* 言語別ルート */}
            <Route path="/:lang" element={<LangHandler />}>
              <Route index element={<IroriTourismSite />} />
            </Route>
            
            {/* 言語別サービスページ */}
            <Route path="/vip-car" element={<VipCarDetail />} />
            <Route path="/:lang/vip-car" element={<VipCarDetail />} />
            
            <Route path="/chiba-gourmet" element={<ChibaGourmetDetail />} />
            <Route path="/:lang/chiba-gourmet" element={<ChibaGourmetDetail />} />
            
            <Route path="/nationwide-transport" element={<NationwideTransportDetail />} />
            <Route path="/:lang/nationwide-transport" element={<NationwideTransportDetail />} />
            
            {/* 開発用ルート */}
            <Route path="/chakra-test" element={<ChakraTestPage />} />
            <Route path="/debug/images" element={<ImageTestComponent />} />
            <Route path="/debug/language" element={<LanguageTestComponent />} />
            <Route path="/demo/vehicle-lineup" element={<VehicleLineupDemo />} />
            
            {/* 将来的な拡張用ルート */}
            <Route path="/tours/:id" element={<div>個別ツアー詳細ページ（実装予定）</div>} />
            <Route path="/:lang/tours/:id" element={<div>個別ツアー詳細ページ（実装予定）</div>} />
            
            <Route path="/booking" element={<div>予約ページ（実装予定）</div>} />
            <Route path="/:lang/booking" element={<div>予約ページ（実装予定）</div>} />
            
            <Route path="/admin" element={<div>管理画面（実装予定）</div>} />
            
            {/* 404ページ */}
            <Route path="*" element={<div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-800 mb-4">404 - ページが見つかりません</h1>
                <p className="text-gray-600 mb-8">お探しのページは存在しないか、移動された可能性があります。</p>
                <a href="/" className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors">
                  ホームに戻る
                </a>
              </div>
            </div>} />
          </Routes>
        </ScrollToSection>
        <Footer />
      </div>
    </Router>
  )
}

export default App
